import { message } from 'odc-shared/components';
import { Suspense } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from 'react-router';

import { RouterConfig, routers } from '@src/config/router.config';

import Layout from './components/Layout';

import './App.scss';

// message 全局配置
message.config({
  top: 64,
});

const buildRedirectUrl = (targetPath: string, currentSearch?: string): string => {
  if (!currentSearch) return targetPath;
  const hasQuery = targetPath.includes('?');
  return hasQuery
    ? `${targetPath}&${currentSearch.slice(1)}`
    : targetPath + currentSearch;
};

function getRouteElement(router: RouterConfig) {
  if (router.component) {
    return <router.component />;
  }
  if (router.redirect) {
    return <Navigate to={buildRedirectUrl(router.redirect, window.location.search)} />;
  }
  return null;
}

function App() {
  return (

    <BrowserRouter>
      <div style={{ display: 'none' }}>
        <button
          id="ot-sdk-btn"
          className="ot-sdk-show-settings"
        />
      </div>
      <Suspense fallback={<div>loading...</div>}>
        <Layout >
          <Routes>
            {routers.map((item) => (
              <Route
                id={item.name}
                key={item.path}
                path={item.path}
                element={getRouteElement(item)}
              />
            ))}
            {/* 404 */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Layout>
      </Suspense>

    </BrowserRouter>

  );
}

export default App;
